<template>
  <div></div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
export default {
  name: 'SSO_AUTH',
  data: () => {
    return {}
  },
  async created () {
    try {
      const ssoConfigRes = await AuthService.getSsoConfig()
      const ssoConfig = ssoConfigRes.data ?? {}
      if (this.$route.query.channel === 'APP') {
        setTimeout(() => {
          window.location = this.$route.fullPath.replace(/\/default/g, ssoConfig.callbackLoginApp)
        }, 2000)
      } else if (this.$route.query.channel === 'WEB') {
        const user = JSON.parse(localStorage.getItem('userData')) ?? {}
        if (user.userId) {
          try {
            window.close()
          } catch (error) {
            
          }
          this.$router.push('/')
          return
        }
        this.$router.push(this.$route.fullPath.replace(/\/default/g, '/sso/auth'))
      } else {
        const user = JSON.parse(localStorage.getItem('userData')) ?? {}
        if (user.userId) {
          try {
            window.close()
          } catch (error) {
            
          }
          this.$router.push('/')
          return
        }
        this.$router.push('/login?nosso=1')
      }
    } catch (error) {
    } finally {
    }
  }
}
</script>
